module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bdmanagement"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("BD管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("添加BD")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "350px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.add_phone_number),
      callback: function($$v) {
        _vm.add_phone_number = $$v
      },
      expression: "add_phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "500px",
      "display": "inline-block",
      "margin-right": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("负责城市")]), _vm._v(" "), _c('a-tree-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "multiple": "",
      "treeData": _vm.newcityoptions,
      "dropdown-style": {
        maxHeight: '400px',
        overflow: 'auto'
      },
      "tree-checkable": "",
      "show-checked-strategy": _vm.SHOW_PARENT
    },
    on: {
      "change": _vm.cityChange
    }
  })], 1), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendbtn
    }
  }, [_vm._v("发送邀请码")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "contentcard",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-bottom": "70px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative"
    }
  }, [_c('a-input-search', {
    staticStyle: {
      "width": "200px",
      "float": "right",
      "margin": "-10px 0 10px 0"
    },
    attrs: {
      "placeholder": "搜索BD"
    },
    on: {
      "search": _vm.onSearchBD
    }
  })], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("负责城市")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1), _vm._v(" "), (_vm.issearchBD) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "border-radius": "4px",
      "padding": "11px 0 0 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.bdlist.length) && (!_vm.issearchBD)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.bdlist), function(user, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(user.nick_name))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      attrs: {
        "src": user.avatar_url,
        "height": "56"
      }
    })]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(user.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [(user.UIC_BD_Cryptographics.length > 0) ? _c('a-tooltip', {
      attrs: {
        "placement": "topRight"
      }
    }, [(JSON.parse(user.UIC_BD_Cryptographics[0].cities).length > 3) ? _c('template', {
      slot: "title"
    }, _vm._l((JSON.parse(user.UIC_BD_Cryptographics[0].cities)), function(city, cityindex) {
      return _c('span', {
        key: cityindex
      }, [_vm._v(_vm._s(city) + "\n\t\t\t\t\t\t\t\t\t\t")])
    }), 0) : _vm._e(), _vm._v(" "), (user.UIC_BD_Cryptographics.length > 0) ? _c('span', [_vm._v(_vm._s(JSON.parse(user.UIC_BD_Cryptographics[0].cities)[0]) + _vm._s(JSON.parse(user.UIC_BD_Cryptographics[0].cities).length > 1 ? ('、' + JSON.parse(user.UIC_BD_Cryptographics[0].cities)[1]) : '') + _vm._s(JSON.parse(user.UIC_BD_Cryptographics[0].cities).length > 2 ? ('等') : ''))]) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_c('div', [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px",
        "margin-right": "10px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.gotoshopkeeper(user)
        }
      }
    }, [_vm._v("查看店主")]), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "ghost": "",
        "disabled": ""
      }
    }, [_vm._v("删除")])], 1)])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.bdsum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)], 2)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1a2626e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/bdmanagement/index.vue
// module id = 2398
// module chunks = 1